module.exports = __webpack_public_path__ + "img/Death-Star-icon.3d9895e2.png";